<template>
    <table class="w-full bg-tableBG dark:bg-dark.tableBG border border-sepBorder dark:border-dark.sepBorder rounded-lg">
        <thead>
            <tr class="bg-gray-100 dark:bg-dark.panels border border-sepBorder dark:border-dark.sepBorder">
                <th class="p-2"><input type="checkbox" @change="toggleSelectAll" /></th>
                <th class="p-2">Account Name</th>
                <th v-for="addon in addons" :key="addon.name" class="p-2">{{ addon.label }}</th>
                <th class="p-2">Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="account in accounts" :key="account.id" class="border-t border-sepBorder dark:border-dark.sepBorder">
                <td class="p-2"><input type="checkbox" v-model="selectedAccounts" :value="account.id" /></td>
                <td class="p-2">{{ account.name }}</td>
                <td v-for="addon in addons" :key="addon.name" class="p-2 text-center">
                    <MazSwitch v-model="account.addons[addon.name]" :disabled="!addon.available" color="primary" />
                </td>
                <td class="p-2">
                    <button @click="manageAddons(account)" class="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600" >
                        Manage
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="mt-4">
        <button v-for="addon in addons" :key="'enable-' + addon.name" @click="bulkEnable(addon.name)" class="mr-2 px-4 py-2 bg-green-500 text-white rounded" >
            Enable {{ addon.label }}
        </button>
    <!-- Add disable buttons here if needed -->
    </div>
</template>

<script>
export default {
    name: 'AccountTable',
    props: { platform: String },
    data() {
        return {
            selectedAccounts: [],
        };
    },
    computed: {
        addons() {
            // Mock data; replace with dynamic fetch from store/API
            const allAddons = {
                onlyfans: [
                { name: 'reposting', label: 'Reposting', available: true },
                { name: 'followExpired', label: 'Follow Expired', available: true },
                { name: 'likes', label: 'Likes for Likes', available: true },
                ],
                fansly: [
                { name: 'reposting', label: 'Reposting', available: true },
                // Add different add-ons for Fansly as needed
                ],
            };
            return allAddons[this.platform] || [];
        },
        accounts() {
            // Mock data; replace with store/API
            return [
            { id: '1', name: '@JaneDoe', platform: 'onlyfans', addons: { reposting: true, followExpired: false, likes: false } },
            { id: '2', name: '@JohnSmith', platform: 'onlyfans', addons: { reposting: false, followExpired: true, likes: false } },
            ].filter(acc => acc.platform === this.platform);
        },
    },
    methods: {
        toggleSelectAll(event) {
            this.selectedAccounts = event.target.checked ? this.accounts.map(acc => acc.id) : [];
        },
        bulkEnable(addonName) {
            console.log(`Enable ${addonName} for accounts:`, this.selectedAccounts);
            // Replace with API call later
        },
        manageAddons(account) {
            this.$router.push(`/addons/${account.id}`);
        },
    },
};
</script>

<style scoped>
/* Add any additional custom styles here if needed */
</style>